<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 gl-xl-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <div class="row" v-if="link_list">
                        <h2>自制</h2>
                        <ul class="row gy-1">
                            <li class="col-6 col-lg-4 col-xl-4" v-for="l in diy_list" :key="l"><a :href="l.link"
                                    target="_blank" rel="nofollow">{{
                                        l.name }}</a>
                            </li>
                        </ul>
                        <h2>捏人</h2>
                        <ul class="row gy-1">
                            <li class="col-6 col-lg-4 col-xl-4" v-for="l in nene_list" :key="l"><a :href="l.link"
                                    target="_blank" rel="nofollow">{{
                                        l.name }}</a>
                            </li>
                        </ul>
                        <h2>辞典</h2>
                        <ul class="row gy-1">
                            <li class="col-6 col-lg-4 col-xl-4" v-for="l in dict_list" :key="l"><a :href="l.link"
                                    target="_blank" rel="nofollow">{{
                                        l.name }}</a>
                            </li>
                        </ul>
                        <h2>教程</h2>
                        <ul class="row gy-1">
                            <li class="col-6 col-lg-4 col-xl-4" v-for="l in docu_list" :key="l"><a :href="l.link"
                                    target="_blank" rel="nofollow">{{
                                        l.name }}</a>
                            </li>
                        </ul>
                        <h2>工具</h2>
                        <ul class="row gy-1">
                            <li class="col-6 col-lg-4 col-xl-4" v-for="l in tool_list" :key="l"><a :href="l.link"
                                    target="_blank" rel="nofollow">{{
                                        l.name }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'

const title = "外站"
const subtitle = "亲测好用"

const link_list = ref()
let diy_list = []
let nene_list = []
let dict_list = []
let docu_list = []
let tool_list = []

const getData = () => {
    var api = '/link.php'
    axios
        .get(api)
        .then(res => {
            link_list.value = res.data
            for (let l of link_list.value) {
                if (l['type'] == '自制') {
                    diy_list.push(l)
                }
                if (l['type'] == '捏人') {
                    nene_list.push(l)
                }
                if (l['type'] == '辞典') {
                    dict_list.push(l)
                }
                if (l['type'] == '教程') {
                    docu_list.push(l)
                }
                if (l['type'] == '工具') {
                    tool_list.push(l)
                }
            }
        })
        .catch(err => {
            console.log(err)
        })
}

onMounted(() => {
    getData()
})

</script>
<style scoped>
h2 {
    margin-bottom: 2rem;
    margin-top: 2rem;
    text-align: center;
}

ul {
    overflow: hidden;
    z-index: 1;
}

li {
    list-style: none;
    float: left;
}

a {
    display: block;
    background: rgba(135, 206, 235);
    color: #FFF;
    font-size: 1.25rem;
    text-align: center;
    padding: .25rem;
    line-height: 2rem;
    border-radius: 2px;
    transition: all 0.2s;
    z-index: 1;
}

a:hover {
    background: rgba(135, 206, 235, 0.2);
    font-size: 1.5rem;
}
</style>